import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TypewriterText from './TypewriterText';
import { getRandomPrompt } from './mindfulPausePrompts';

/**
 * MindfulPausePrompt Component
 * Displays a mindful pause prompt while waiting for AI responses
 * Uses local prompts with typewriter animation
 */
const MindfulPausePrompt = ({ onAnswerReady = null, showAnswerButton = false }) => {
  const [prompt, setPrompt] = useState(null);
  const [lastPromptId, setLastPromptId] = useState(null);

  useEffect(() => {
    selectRandomPrompt();
  }, []);

  const selectRandomPrompt = () => {
    const randomPrompt = getRandomPrompt(lastPromptId);
    setPrompt(randomPrompt);
    setLastPromptId(randomPrompt.id);
  };

  return (
    <div className="flex flex-col items-center mt-6 mb-4 px-4">
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl shadow-md p-6 max-w-2xl w-full border border-indigo-100">
        {/* Header */}
        <div className="text-center mb-4">
          <h3 className="text-lg font-semibold text-indigo-700">
            While you wait for your verified answer…
          </h3>
        </div>

        {/* Prompt with typewriter animation */}
        <div className="text-center text-gray-700 text-base leading-relaxed min-h-[60px] flex items-center justify-center">
          {prompt && (
            <TypewriterText
              text={prompt.text}
              speed={40}
            />
          )}
        </div>

        {/* Answer Ready Button */}
        {showAnswerButton && onAnswerReady && (
          <div className="mt-6 text-center">
            <button
              onClick={onAnswerReady}
              className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-semibold py-3 px-8 rounded-full shadow-lg transform transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              ✨ Answer Ready!
            </button>
          </div>
        )}
      </div>

      {/* Loading Animation Below */}
      <div className="mt-4">
        <img
          src="/loading.gif"
          alt="Loading..."
          className="w-24 h-24 rounded-full opacity-80"
        />
      </div>
    </div>
  );
};

MindfulPausePrompt.propTypes = {
  onAnswerReady: PropTypes.func,
  showAnswerButton: PropTypes.bool,
};

export default MindfulPausePrompt;
